(() => {
  function init(root) {
    if (root.dataset.catalogueReady) return;
    const grid = root.querySelector('[data-catalogue-grid]');
    const cards = Array.from(grid.querySelectorAll('[data-plant-card]'));
    // Never filter a partial catalogue if the range grows beyond the server page.
    if (cards.length !== Number(root.dataset.total)) return;
    root.dataset.catalogueReady = 'true';
    const form = root.querySelector('[data-plant-controls]');
    const search = root.querySelector('[data-catalogue-search]');
    const filters = Array.from(root.querySelectorAll('[data-catalogue-filter]'));
    const sort = root.querySelector('[data-catalogue-sort]');
    const count = root.querySelector('[data-catalogue-count]');
    const empty = root.querySelector('[data-catalogue-empty]');
    const pages = root.querySelector('[data-catalogue-pages]');
    const copy = JSON.parse(root.querySelector('[data-catalogue-copy]').textContent);
    const perPage = Number(root.dataset.perPage);
    const normalize = text => String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const genus = filters.find(el => el.dataset.catalogueFilter === 'genus');
    Array.from(new Set(cards.map(card => card.dataset.genus).filter(Boolean))).sort().forEach(name => {
      genus.add(new Option(name, name));
    });
    let currentPage = 1;
    function readState() {
      const query = new URL(location.href).searchParams;
      search.value = query.get('plant_q') || '';
      filters.forEach(el => { el.value = query.get('plant_' + el.dataset.catalogueFilter) || ''; });
      sort.value = query.get('plant_sort') === 'za' ? 'za' : 'az';
      currentPage = Math.max(1, Number.parseInt(query.get('plant_page'), 10) || 1);
    }
    function writeState() {
      const url = new URL(location.href);
      const set = (key, value) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key);
      set('plant_q', search.value.trim());
      filters.forEach(el => set('plant_' + el.dataset.catalogueFilter, el.value));
      set('plant_sort', sort.value === 'za' ? 'za' : '');
      set('plant_page', currentPage > 1 ? String(currentPage) : '');
      history.replaceState(null, '', url);
    }
    function render(updateURL = true) {
      const term = normalize(search.value.trim());
      const matches = cards.filter(card => normalize(card.dataset.search).includes(term) &&
        filters.every(el => !el.value || card.dataset[el.dataset.catalogueFilter] === el.value));
      matches.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang, {sensitivity: 'base'}) * (sort.value === 'za' ? -1 : 1));
      const pageCount = Math.max(1, Math.ceil(matches.length / perPage));
      currentPage = Math.min(currentPage, pageCount);
      grid.replaceChildren(...matches.slice((currentPage - 1) * perPage, currentPage * perPage));
      count.textContent = (matches.length === 1 ? copy.one : copy.other).replace('#', String(matches.length));
      empty.hidden = matches.length > 0;
      pages.replaceChildren();
      pages.hidden = pageCount < 2;
      for (let page = 1; page <= pageCount; page++) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'sl-chip'; button.textContent = String(page);
        button.setAttribute('aria-label', copy.page.replace('#', String(page)));
        if (page === currentPage) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => { currentPage = page; render(); count.scrollIntoView({block: 'start', behavior: 'smooth'}); pages.querySelector('[aria-current]')?.focus({preventScroll: true}); });
        pages.append(button);
      }
      if (updateURL) writeState();
    }
    form.addEventListener('submit', e => {e.preventDefault(); currentPage = 1; render();});
    search.addEventListener('input', () => { currentPage = 1; render(); });
    filters.concat(sort).forEach(el => el.addEventListener('change', () => {currentPage = 1; render();}));
    form.addEventListener('reset', event => {
      event.preventDefault();
      search.value = '';
      filters.forEach(el => {el.value = '';});
      sort.value = 'az'; currentPage = 1; render();
    });
    window.addEventListener('popstate', () => {readState(); render(false);});
    readState(); render(false);
  }
  function initialize(scope = document) { scope.querySelectorAll('[data-invitro-catalogue]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
